import { createContext } from "react"

export const TimerContext = createContext<{
    currentTime: number,
    timerStatus: boolean,
    turnOnTimer: () => void,
    turnOffTimer: () => void,
}>({
    currentTime: 5,
    timerStatus: false,
    turnOnTimer: () => {
    },
    turnOffTimer: () => {
    },
})